module.exports = __webpack_public_path__ + "img/head-details-banner.5033aa56.jpg";